import React from 'react';
import Icon from '../../../components/AppIcon';

const CalendarGrid = ({ dates, selectedDate, onDateSelect, isLoading }) => {
  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const isToday = (date) => {
    const today = new Date();
    return date?.toDateString() === today?.toDateString();
  };

  const isSelected = (date) => {
    return selectedDate && date?.toDateString() === selectedDate?.toDateString();
  };

  return (
    <div className="bg-card rounded-xl md:rounded-2xl shadow-sm border border-border p-4 md:p-6 lg:p-8 relative">
      {isLoading && (
        <div className="absolute inset-0 bg-card/80 backdrop-blur-sm rounded-xl md:rounded-2xl flex items-center justify-center z-10">
          <div className="flex flex-col items-center gap-3">
            <Icon name="Loader" size={32} className="animate-spin text-primary" />
            <p className="text-sm text-muted-foreground font-caption">Loading availability...</p>
          </div>
        </div>
      )}
      <div className="grid grid-cols-7 gap-2 md:gap-3 lg:gap-4 mb-3 md:mb-4">
        {weekDays?.map((day) => (
          <div
            key={day}
            className="text-center font-caption font-medium text-xs md:text-sm text-muted-foreground py-2"
          >
            {day}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-2 md:gap-3 lg:gap-4">
        {dates?.map((dateObj, index) => {
          const { date, isCurrentMonth, isAvailable,dateSlotId  } = dateObj;
          const today = isToday(date);
          const selected = isSelected(date);

          return (
            <button
              key={index}
              onClick={() => isAvailable && isCurrentMonth && onDateSelect(date, dateSlotId)}
              disabled={!isAvailable || !isCurrentMonth || isLoading}
              className={`
                aspect-square rounded-lg md:rounded-xl flex flex-col items-center justify-center
                transition-all duration-250 ease-elegant font-caption
                ${!isCurrentMonth ? 'opacity-30 cursor-default' : ''}
                ${!isAvailable && isCurrentMonth ? 'opacity-50 cursor-not-allowed bg-muted' : ''}
                ${isAvailable && isCurrentMonth && !selected ? 'hover:bg-primary/10 hover:scale-110 active:scale-95 cursor-pointer' : ''}
                ${selected ? 'bg-gradient-to-br from-primary to-secondary text-primary-foreground shadow-md scale-105' : 'text-foreground'}
                ${today && !selected ? 'ring-2 ring-primary ring-offset-2' : ''}
                ${isLoading ? 'pointer-events-none' : ''}
              `}
              aria-label={`${date?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}${!isAvailable ? ' - Unavailable' : ''}${selected ? ' - Selected' : ''}`}
            >
              <span className="text-base md:text-lg lg:text-xl font-medium">
                {date?.getDate()}
              </span>
              {isAvailable && isCurrentMonth && !selected && (
                <span className="hidden sm:block text-xs mt-0.5 opacity-70 truncate">Available</span>
              )}
              {!isAvailable && isCurrentMonth && (
                <span className="text-xs mt-0.5">x</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarGrid;